import React, { Component } from 'react';

import { SectionTitle, SectionDescription, BoxContentIcon }  from '../../helpers/section';
import { isMobile } from 'react-device-detect';
import { Link } from 'react-router-dom';

const desc = "Desde 1996 a Ideal Brasil é uma empresa conceitual, desenvolvendo e " +
"fabricando estruturas metálicas galvanizadas a fogo para sistemas de telecomunicação. O foco " +
"é atuar sempre com qualidade e agilidade em relação ao desenvolvimento, à fabricação e à " +
"instalação própria. A Ideal atende todo o Brasil e exterior com soluções e inovações para " +
"melhoria contínua de seus produtos, objetivando as mais variadas necessidades dos clientes."; 

const desc1 = "A área de negócios Soluções em Telecomunicações foi criada em 2015 para atender a uma " +
"demanda crescente de comunicação para empresas de Utilities, principalmente de energia " +
"elétrica. Seja ela de geração, transmissão ou distribuição. ";

const desc2 = "Desde então, a Ideal Brasil Soluções de Acesso está proporcionando ao mercado brasileiro os " +
"mais especializados recursos de infraestrutura de TI, voz, vídeo e serviços profissionais, que " +
"proporcionam tranquilidade para as necessidades de cada projeto. Seja para o " +
"desenvolvimento do projeto, fornecimento de equipamentos ou para a prestação de serviços " +
"especializados de instalação, configuração e testes.";

const desc3 = "O portfólio apresenta um conjunto completo de soluções que viabiliza suas necessidades de telecomunicações e TI. ";

const mvl = [
    {col: 'col-12 col-md-4 col-lg-4', icon:'mission',title: 'Missão', description: 'Entender e atender o mercado de estruturas metálicas para telecomunicação com excelência em todos os seus quesitos, principalmente com agilidade (just in time), qualidade e cordialidade.'},
    {col: 'col-12 col-md-4 col-lg-4', icon:'vision',title: 'Visão', description: 'Atender com excelência as principais empresas de telecomunicação do país.'},
    {col: 'col-12 col-md-4 col-lg-4', icon:'value',title: 'Valores', description: 'Nossa cultura é baseada em valores, como integridade, coragem, trabalho em equipe e comprometimento.'}
];

class About extends Component {
    render() {
        return (
            <section className={ isMobile ? 'home-about-mobile' : 'home-about'} id="about" >
                <div className="container">
                    {SectionTitle({section: 'Empresa', subtitle:'CONHEÇA A', featured: 'IDEAL BRASIL'})}
                    {SectionDescription(desc)}  
                    {SectionDescription(desc1)}  
                    {SectionDescription(desc2)}  
                    {SectionDescription(desc3)}             
                    <div className="row">
                        <div className="col-12 mt-50">
                            {SectionTitle({section: 'Parceiros', subtitle:'CONHEÇA NOSSOS', featured: 'PARCEIROS'})}
                        </div>                        
                    </div>
                    <div class="row justify-content-md-center">
                        <div class="col-6 col-md-2">
                            <Link to={'/4rf'} className="link">
                                <picture>
                                        <img srcSet={process.env.PUBLIC_URL +'/assets/images/logo-4rf.png'} src="" alt="4RF" title="4RF" className="img-fluid" />
                                </picture>
                            </Link>    
                        </div>
                        <div class="col-6 col-md-2">
                            <Link to={'/rad'} className="link">
                                <picture>
                                        <img srcSet={process.env.PUBLIC_URL +'/assets/images/logo-rad.png'} src="" alt="4RF" title="4RF" className="img-fluid" />
                                </picture>
                            </Link>
                        </div>
                    </div>    
                            
                    
                    <div className="row">
                        {mvl.map((item,key) => { return BoxContentIcon(item,key) } )}
                    </div>                 
                </div>
            </section>
        )
    }
}

export default About;
